import { __awaiter, __generator } from "tslib";
import { getLang, axios } from '@tencent/vb-web-base';
import { iframeOpen, to } from '@tencent/vb-web-base-core';
// 這裡之所以 配置多語言是因為如果作為模塊直接被其他模塊引用多話 在當前項目配置多語言是顯示不出來的
var langMap = {
    合同预览异常: {
        'zh-HK': '合同預覽異常',
        'en-GB': 'Contract get error',
        'zh-CN': '合同预览异常',
    },
    获取配置异常: {
        'zh-HK': '獲取配置異常',
        'en-GB': 'Configuration get error',
        'zh-CN': '获取配置异常',
    },
    模版参数异常: {
        'zh-HK': '獲取配置異常',
        'en-GB': '模板參數異常',
        'zh-CN': '模版参数异常',
    },
    检查合同签约异常: {
        'zh-HK': '檢查合同簽約異常',
        'en-GB': 'Check contract signing error',
        'zh-CN': '检查合同签约异常',
    },
    获取账户信息异常: {
        'zh-HK': '獲取帳戶信息異常',
        'en-GB': 'Account get error',
        'zh-CN': '获取账户信息异常',
    },
    签约异常: {
        'zh-HK': '簽約異常',
        'en-GB': 'Signing error',
        'zh-CN': '签约异常',
    },
    配置key不存在: {
        'zh-HK': '配置key不存在',
        'en-GB': 'Config key does not exist',
        'zh-CN': '配置key不存在',
    },
    获取协议内容异常: {
        'zh-HK': '獲取協議內容異常',
        'en-GB': 'Protocol content error',
        'zh-CN': '获取协议内容异常',
    },
    获取协议内容数据异常: {
        'zh-HK': '獲取協議內容數據異常',
        'en-GB': 'Protocol content data error',
        'zh-CN': '获取协议内容数据异常',
    },
    获取子合同信息异常: {
        'zh-HK': '獲取子合同信息異常',
        'en-GB': 'Sub-contract error',
        'zh-CN': '获取子合同信息异常',
    },
};
var innerLangMap = function (cnTxt) { return __awaiter(void 0, void 0, void 0, function () {
    var curLang, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, getLang()];
            case 1:
                curLang = _a.sent();
                if (langMap[cnTxt]) {
                    return [2 /*return*/, langMap[cnTxt][curLang] || cnTxt];
                }
                return [2 /*return*/, cnTxt];
            case 2:
                error_1 = _a.sent();
                return [2 /*return*/, cnTxt];
            case 3: return [2 /*return*/];
        }
    });
}); };
var Contract = /** @class */ (function () {
    // private version: IVersion = 'v1';
    function Contract(info) {
        this.acctNo = '';
        this.checkType = true;
        this.contractInfo = info;
        // this.version = info.version || 'v1';
    }
    // needCheckMainType() {
    //   return this.version === 'v1' ? true : false;
    // }
    Contract.prototype.getConf = function () {
        return __awaiter(this, void 0, void 0, function () {
            var errorTips, noKeyConfigTips, _a, confDataRsp, err, confData, codeShow, msg;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.contractInfo.keyType) {
                            return [2 /*return*/, {
                                    busKey: '',
                                    tplId: this.contractInfo.key,
                                    mainContractType: '',
                                    subContractType: '',
                                    previewTpl: [],
                                    childTpl: [],
                                    relateDetailTemData: [],
                                }];
                        }
                        if (this.confData) {
                            return [2 /*return*/, this.confData];
                        }
                        return [4 /*yield*/, innerLangMap('获取配置异常')];
                    case 1:
                        errorTips = _b.sent();
                        return [4 /*yield*/, innerLangMap('配置key不存在')];
                    case 2:
                        noKeyConfigTips = _b.sent();
                        noKeyConfigTips = noKeyConfigTips + "(" + this.contractInfo.key + ")";
                        return [4 /*yield*/, to(axios.get('/node/common/contract/prevewConf', {
                                params: {
                                    key: this.contractInfo.key,
                                },
                            }))];
                    case 3:
                        _a = _b.sent(), confDataRsp = _a[0], err = _a[1];
                        if (err) {
                            throw { code: err.response.status, message: errorTips, tag: 'error' };
                        }
                        confData = confDataRsp.data;
                        if (confData.code !== 0 || !confData.data[0]) {
                            codeShow = confData.code;
                            msg = confData.message;
                            if (!confData.data[0]) {
                                codeShow = -1;
                                msg = noKeyConfigTips;
                            }
                            throw { code: codeShow, message: msg, userTag: 'configProblem' };
                        }
                        this.confData = confData.data[0];
                        return [2 /*return*/, this.confData];
                }
            });
        });
    };
    Contract.prototype.viewProto = function () {
        var url = "/h5/contract/contract/index.html?key=" + this.contractInfo.key + "&contractType=proto&isLogin=no&needAccount=no";
        var hideBtn = this.contractInfo.hideBtn === undefined ? 'yes' : this.contractInfo.hideBtn === true ? 'yes' : 'no';
        var needTitle = this.contractInfo.needTitle === undefined ? 'yes' : this.contractInfo.needTitle === true ? 'yes' : 'no';
        // let needCopyRight =
        //   this.contractInfo.needCopyRight === undefined ? 'yes' : this.contractInfo.needCopyRight === true ? 'yes' : 'no';
        // if (isFusionBankApp) {
        //   needCopyRight = 'no';
        // }
        url = url + "&hideBtn=" + hideBtn;
        url = url + "&needTitle=" + needTitle;
        // url = `${url}&needCopyRight=${needCopyRight}`;
        if (this.contractInfo.btnTitle) {
            url = url + "&btnTitle=" + this.contractInfo.btnTitle;
        }
        url = url + "&footerComment=" + (this.contractInfo.footerComment || '');
        url = url + "&setWindowTopTitle=1";
        if (!this.contractInfo.viewType || this.contractInfo.viewType === 'iframe') {
            url = url + "&__containerType=dialog";
            return iframeOpen(url);
        }
        else {
            url = url + "&__containerType=normal";
            if (window.top) {
                window.top.location.href = url;
            }
            else {
                window.location.href = url;
            }
        }
    };
    Contract.prototype.preview = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, autoSign, needLogin, needAccount, needFinger, needAgree, needBackBtn, needTitle, needCheckBox, containerType;
            return __generator(this, function (_a) {
                url = "/h5/contract/contract/index.html?key=" + this.contractInfo.key;
                autoSign = this.contractInfo.autoSign ? 'yes' : 'no';
                needLogin = this.contractInfo.needLogin === undefined ? 'yes' : this.contractInfo.needLogin === true ? 'yes' : 'no';
                needAccount = this.contractInfo.needAccount ? 'yes' : 'no';
                needFinger = this.contractInfo.needFinger === undefined ? 'no' : this.contractInfo.needFinger === true ? 'yes' : 'no';
                needAgree = this.contractInfo.needAgree ? 'yes' : 'no';
                needBackBtn = this.contractInfo.needBackBtn === undefined ? 'yes' : this.contractInfo.needBackBtn === true ? 'yes' : 'no';
                needTitle = this.contractInfo.needTitle === undefined ? 'yes' : this.contractInfo.needTitle === true ? 'yes' : 'no';
                needCheckBox = this.contractInfo.needCheckBox === undefined ? 'yes' : this.contractInfo.needCheckBox === true ? 'yes' : 'no';
                // if (this.contractInfo.alarmText) {
                //   // 外面传进来的如果带有英文版的双引号 安卓底下拉不起来 暂时先这样解决 做下替换
                //   this.contractInfo.alarmText = this.contractInfo.alarmText.replace(/\"/g, '~@~');
                // }
                if (this.contractInfo.noClose) {
                    url = url + "&noClose=yes";
                }
                if (this.contractInfo.keyType) {
                    url = url + "&keyType=" + this.contractInfo.keyType;
                }
                if (this.contractInfo.hideBtn === true) {
                    url = url + "&hideBtn=yes";
                }
                if (!this.contractInfo.type) {
                    url = url + "&contractType=contract";
                }
                if (this.contractInfo.btnTitle) {
                    url = url + "&btnTitle=" + this.contractInfo.btnTitle;
                }
                url = url + "&customTitle=" + (this.contractInfo.customTitle || '');
                containerType = this.contractInfo.containerType || 'dialog';
                url = url + "&__containerType=" + containerType;
                url = url + "&isLogin=" + needLogin;
                url = url + "&needAccount=" + needAccount;
                url = url + "&autoSign=" + autoSign;
                url = url + "&needAgree=" + needAgree;
                url = url + "&needCheckBox=" + needCheckBox;
                url = url + "&needBackBtn=" + needBackBtn;
                url = url + "&needTitle=" + needTitle;
                // url = `${url}&needCopyRight=${needCopyRight}`;
                url = url + "&alarmText=" + (this.contractInfo.alarmText || '');
                url = url + "&policyText=" + (this.contractInfo.policyText || '');
                url = url + "&footerComment=" + (this.contractInfo.footerComment || '');
                // 如果升级了api，在合同页面里面 会通过window.top.title改顶部window标题，没升级的的暂时不动 这是平滑兼容的过渡阶段setWindowTopTitle=1
                url = url + "&setWindowTopTitle=1";
                url = url + "&needFinger=" + needFinger;
                // url = `${url}&version=${this.version}`;
                if (!this.contractInfo.viewType || this.contractInfo.viewType === 'iframe') {
                    return [2 /*return*/, iframeOpen(url)];
                }
                else {
                    if (window.top) {
                        window.top.location.href = url;
                    }
                    else {
                        window.location.href = url;
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    Contract.prototype.getPreviewContent = function (preview) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.contractInfo.type === 'proto')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getProtoContent()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, this.getContractContent(preview)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Contract.prototype.getContractContent = function (preview) {
        return __awaiter(this, void 0, void 0, function () {
            var returnObj, preConf, needLoginTag, prevPromise, _a, contractDataRsp, err, msg, errorTips, contractData, dataCode, arr, res;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        returnObj = {
                            code: 0,
                            msg: '',
                            contents: [],
                            title: '',
                            titleList: [],
                            relateDetailTemData: [],
                            subContractList: [],
                            errMsg: '',
                        };
                        return [4 /*yield*/, this.getConf()];
                    case 1:
                        preConf = _b.sent();
                        needLoginTag = preview.needLogin || 'no';
                        if (needLoginTag === 'no') {
                            prevPromise = axios.get('/node/common/contract/contractsPreviewPure', {
                                params: {
                                    id: preConf.tplId,
                                },
                            });
                        }
                        else {
                            prevPromise = axios.get('/node/common/contract/contractsPreview', {
                                params: {
                                    id: preConf.tplId,
                                    needAccount: preview.needAccount,
                                },
                            });
                        }
                        return [4 /*yield*/, to(prevPromise)];
                    case 2:
                        _a = _b.sent(), contractDataRsp = _a[0], err = _a[1];
                        if (!(err !== null)) return [3 /*break*/, 4];
                        return [4 /*yield*/, innerLangMap('合同预览异常')];
                    case 3:
                        msg = _b.sent();
                        errorTips = msg + "(" + err.response.status + ")";
                        throw { code: err.response.status, message: errorTips, tag: 'error' };
                    case 4:
                        contractData = contractDataRsp.data;
                        dataCode = contractData.code;
                        if (dataCode !== 0) {
                            throw { code: dataCode, message: contractData.message, userTag: 'getContentProblem' };
                        }
                        returnObj.contents = [
                            {
                                content: contractData.data.content,
                                title: contractData.data.title,
                                relateDetailTem: '',
                                cosUrl: contractData.data.cosUrl || '',
                                tmpId: contractData.data.tmpId,
                            },
                        ];
                        returnObj.title = contractData.data.title;
                        returnObj.subContractList = contractData.data.subContractList || [];
                        this.acctNo = contractData.data.acctNo || '';
                        if (!Array.isArray(preConf.previewTpl)) return [3 /*break*/, 6];
                        arr = preConf.previewTpl.map(function (i) {
                            if (needLoginTag === 'no') {
                                prevPromise = axios.get('/node/common/contract/contractsPreviewPure', {
                                    params: {
                                        id: i.tplId,
                                    },
                                });
                            }
                            else {
                                prevPromise = axios.get('/node/common/contract/contractsPreview', {
                                    params: {
                                        id: i.tplId,
                                        needAccount: preview.needAccount,
                                    },
                                });
                            }
                            return prevPromise;
                        });
                        return [4 /*yield*/, Promise.all(arr)];
                    case 5:
                        res = _b.sent();
                        res.forEach(function (i, index) {
                            if (i.data.code !== 0) {
                                throw { code: i.data.code, message: i.data.message, userTag: 'getPreviewContentProblem' };
                            }
                            // 查找简要模版中的详细模版
                            var relateDetailTarget = preConf.content.childTpl.find(function (k) { return k.simpleKey === preConf.previewTpl[index].busKey; });
                            var relateDetailTem = (relateDetailTarget === null || relateDetailTarget === void 0 ? void 0 : relateDetailTarget.busKey) || '';
                            returnObj.contents.push({
                                content: i.data.data.content,
                                title: i.data.data.title,
                                relateDetailTem: relateDetailTem,
                                cosUrl: i.data.data.cosUrl || '',
                                tmpId: i.data.data.tmpId,
                            });
                        });
                        _b.label = 6;
                    case 6: return [2 /*return*/, returnObj];
                }
            });
        });
    };
    Contract.prototype.checkSign = function () {
        return __awaiter(this, void 0, void 0, function () {
            var returnObj, conf, errorTipsTempl, keys, _a, checkDataRsp, err, msg, checkRsp;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        returnObj = {
                            code: 0,
                            msg: '',
                            contractId: '',
                            errMsg: '',
                        };
                        return [4 /*yield*/, this.getConf()];
                    case 1:
                        conf = _b.sent();
                        return [4 /*yield*/, innerLangMap('模版参数异常')];
                    case 2:
                        errorTipsTempl = _b.sent();
                        keys = [conf.busKey];
                        if (!conf.mainContractType || !conf.subContractType) {
                            this.checkType = false;
                        }
                        if (conf.childTpl && conf.childTpl.length > 0) {
                            conf.childTpl.forEach(function (i) {
                                // if (checkType === true && (!i.mainContractType || !i.subContractType)) {
                                //   throw { code: -3, message: errorTipsTempl, userTag: 'templateProblem' };
                                // }
                                keys.push(i.busKey);
                            });
                        }
                        if (conf.previewTpl && conf.previewTpl.length > 0) {
                            conf.previewTpl.forEach(function (i) {
                                var relateDetailChild = conf.content.childTpl.find(function (k) { return k.simpleKey === i.busKey; });
                                if (relateDetailChild === null || relateDetailChild === void 0 ? void 0 : relateDetailChild.busKey) {
                                    var targetDetail = conf.relateDetailTemData.find(function (ritem) { return ritem.busKey === relateDetailChild.busKey; });
                                    // if (checkType === true && (!targetDetail.mainContractType || !targetDetail.subContractType)) {
                                    //   throw { code: -3, message: errorTipsTempl, userTag: 'templateProblem' };
                                    // }
                                    keys.push(targetDetail.busKey);
                                }
                                else {
                                    // if (checkType === true && (!i.mainContractType || !i.subContractType)) {
                                    //   throw { code: -3, message: errorTipsTempl, userTag: 'templateProblem' };
                                    // }
                                    keys.push(i.busKey);
                                }
                            });
                        }
                        return [4 /*yield*/, to(axios.get('/node/common/contract/checkContractBatchByType', {
                                params: {
                                    keys: keys.join(','),
                                    checkType: this.checkType === true ? 'yes' : 'no',
                                },
                            }))];
                    case 3:
                        _a = _b.sent(), checkDataRsp = _a[0], err = _a[1];
                        if (!err) return [3 /*break*/, 5];
                        return [4 /*yield*/, innerLangMap('检查合同签约异常')];
                    case 4:
                        msg = _b.sent();
                        throw { code: err.response.status, message: msg, tag: 'error' };
                    case 5:
                        checkRsp = checkDataRsp.data;
                        if (checkRsp.code !== 0) {
                            if (checkRsp.code === 1043162009) {
                                returnObj.code = 0;
                                returnObj.msg = 'noContract';
                                return [2 /*return*/, returnObj];
                            }
                            throw { code: checkRsp.code, message: checkRsp.message, userTag: 'checkContractProblem' };
                        }
                        else if (checkRsp.data.noFoundList.length > 0) {
                            // 为0的情况下一定会有data
                            returnObj.code = 0;
                            returnObj.msg = 'noContract';
                            return [2 /*return*/, returnObj];
                        }
                        returnObj.msg = 'hasContract';
                        // returnObj.contractId = checkRsp.data.contractId
                        return [2 /*return*/, returnObj];
                }
            });
        });
    };
    Contract.prototype.getSubProtoContent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var subContentRsp;
            return __generator(this, function (_a) {
                subContentRsp = {
                    msg: '',
                    content: [],
                };
                return [2 /*return*/, subContentRsp];
            });
        });
    };
    Contract.prototype.getSubContractContent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var conf, subContentRsp, tplIds, _a, batchTplTitleRsp, batchErr, errorTips;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getConf()];
                    case 1:
                        conf = _b.sent();
                        subContentRsp = {
                            msg: '',
                            content: [],
                        };
                        tplIds = [];
                        if (!(conf.childTpl && conf.childTpl.length > 0)) return [3 /*break*/, 5];
                        conf.childTpl.forEach(function (i) {
                            tplIds.push(i.busKey);
                        });
                        return [4 /*yield*/, to(axios.get('/node/common/contract/getTemplateBatch', {
                                params: {
                                    keys: tplIds.join(','),
                                },
                            }))];
                    case 2:
                        _a = _b.sent(), batchTplTitleRsp = _a[0], batchErr = _a[1];
                        if (!batchErr) return [3 /*break*/, 4];
                        return [4 /*yield*/, innerLangMap('获取子合同信息异常')];
                    case 3:
                        errorTips = (_b.sent()) + "(" + batchErr.response.status + ")";
                        throw { code: batchErr.response.status, message: errorTips, tag: 'error' };
                    case 4:
                        if (batchTplTitleRsp.data.code !== 0) {
                            throw {
                                code: batchTplTitleRsp.data.code,
                                message: batchTplTitleRsp.data.message,
                                userTag: 'getSubContProblem',
                            };
                        }
                        subContentRsp.msg = 'suc';
                        subContentRsp.content = batchTplTitleRsp.data.data.mapList;
                        return [3 /*break*/, 6];
                    case 5:
                        subContentRsp.msg = 'suc';
                        _b.label = 6;
                    case 6: return [2 /*return*/, subContentRsp];
                }
            });
        });
    };
    Contract.prototype.getSubContent = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.contractInfo.type === 'proto')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getSubProtoContent()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, this.getSubContractContent()];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Contract.prototype.getProtoContent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var returnObj, _a, confData, err, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        returnObj = {
                            msg: '',
                            contents: [],
                            title: '',
                            titleList: [],
                            subContractList: [],
                            relateDetailTemData: [],
                            errMsg: '',
                            code: 0,
                        };
                        return [4 /*yield*/, to(axios.get('/node/common/contract/protoConf', {
                                params: {
                                    key: this.contractInfo.key,
                                },
                            }))];
                    case 1:
                        _a = _d.sent(), confData = _a[0], err = _a[1];
                        if (!(err || (confData.data.data && !confData.data.data[0]))) return [3 /*break*/, 5];
                        if (!err) return [3 /*break*/, 3];
                        _b = { code: err.response.status };
                        return [4 /*yield*/, innerLangMap('获取协议内容异常')];
                    case 2: throw _b.message = _d.sent(), _b.tag = 'getProtoError', _b;
                    case 3:
                        _c = { code: 500 };
                        return [4 /*yield*/, innerLangMap('获取协议内容数据异常')];
                    case 4: throw _c.message = _d.sent(), _c.tag = 'getProtoDataError', _c;
                    case 5:
                        if (confData.data.code !== 0) {
                            throw { code: confData.data.code, message: confData.data.message, userTag: 'getProtoProblem' };
                        }
                        returnObj.contents = [{ content: confData.data.data[0].content, title: confData.data.data[0].title }];
                        returnObj.title = confData.data.data[0].title;
                        return [2 /*return*/, returnObj];
                }
            });
        });
    };
    Contract.prototype.sign = function () {
        return __awaiter(this, void 0, void 0, function () {
            var conf, _a, accListDataRsp, err, errorTips, errorTipsTempl, accListRsp, signInfo;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getConf()];
                    case 1:
                        conf = _b.sent();
                        return [4 /*yield*/, to(axios.get('/node/account/sub/list'))];
                    case 2:
                        _a = _b.sent(), accListDataRsp = _a[0], err = _a[1];
                        return [4 /*yield*/, innerLangMap('获取账户信息异常')];
                    case 3:
                        errorTips = _b.sent();
                        return [4 /*yield*/, innerLangMap('模版参数异常')];
                    case 4:
                        errorTipsTempl = _b.sent();
                        if (err) {
                            throw { code: err.response.status, message: errorTips, tag: 'error' };
                        }
                        accListRsp = accListDataRsp.data;
                        if (accListRsp.code !== 0 || accListRsp.data.list.length === 0) {
                            // signRsp.msg = 'noAccNo'
                            if (accListRsp.code !== 0) {
                                throw { code: accListRsp.code, message: accListRsp.message, userTag: 'getAccountProblem' };
                            }
                            else {
                                throw { code: -2, message: errorTips, userTag: 'getAccountDataError' };
                            }
                        }
                        this.acctNo = accListRsp.data.list[0].acctNao;
                        if (!conf.mainContractType || !conf.subContractType) {
                            this.checkType = false;
                        }
                        signInfo = [];
                        signInfo.push({
                            busKey: conf.busKey,
                        });
                        if (conf.previewTpl.length > 0) {
                            conf.previewTpl.map(function (item) {
                                // 如果有详情模版用详情模版的id
                                // 有relateDetailTem 就一定有relateDetailTemData
                                var relateDetailChild = conf.content.childTpl.find(function (k) { return k.simpleKey === item.busKey; });
                                if (relateDetailChild === null || relateDetailChild === void 0 ? void 0 : relateDetailChild.busKey) {
                                    var targetDetail = conf.relateDetailTemData.find(function (ritem) { return ritem.busKey === relateDetailChild.busKey; });
                                    // if (checkType === true && (!targetDetail.mainContractType || targetDetail.subContractType)) {
                                    //   throw { code: -3, message: errorTipsTempl, userTag: 'templateProblem' };
                                    // }
                                    signInfo.push({
                                        busKey: targetDetail.busKey,
                                    });
                                }
                                else {
                                    // if (checkType === true && (!item.mainContractType || item.subContractType)) {
                                    //   throw { code: -3, message: errorTipsTempl, userTag: 'templateProblem' };
                                    // }
                                    signInfo.push({
                                        busKey: item.busKey,
                                    });
                                }
                            });
                        }
                        if (conf.childTpl.length > 0) {
                            conf.childTpl.forEach(function (item) {
                                // if (checkType === true && (!item.mainContractType || item.subContractType)) {
                                //   throw { code: -3, message: errorTipsTempl, userTag: 'templateProblem' };
                                // }
                                signInfo.push({
                                    busKey: item.busKey,
                                });
                            });
                        }
                        return [2 /*return*/, this.signBatch(signInfo)];
                }
            });
        });
    };
    Contract.prototype.signBatch = function (signInfo) {
        return __awaiter(this, void 0, void 0, function () {
            var signRsp, signMode, _a, commmrespDataRsp, err, errorTips, commmrespData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        signRsp = {
                            msg: '',
                            code: 0,
                            errMsg: '',
                        };
                        signMode = this.checkType === true ? '1' : '2';
                        return [4 /*yield*/, to(axios.post('/java/contract/common/signContract', {
                                signInfo: JSON.stringify(signInfo),
                                acctNo: this.acctNo,
                                signMode: signMode,
                            }))];
                    case 1:
                        _a = _b.sent(), commmrespDataRsp = _a[0], err = _a[1];
                        return [4 /*yield*/, innerLangMap('签约异常')];
                    case 2:
                        errorTips = _b.sent();
                        if (err) {
                            throw { code: err.response.status, message: errorTips, tag: 'error' };
                            // throw AppErrorWrapper(err, errorTips, 'signBatchError')
                        }
                        commmrespData = commmrespDataRsp.data;
                        if (commmrespData.code !== 0) {
                            if (commmrespData.code === 1048460005) {
                                signRsp.msg = 'hasSign';
                            }
                            else {
                                throw { code: commmrespData.code, message: commmrespData.message, userTag: 'signBatchProblem' };
                            }
                            return [2 /*return*/, signRsp];
                        }
                        signRsp.msg = 'suc';
                        return [2 /*return*/, signRsp];
                }
            });
        });
    };
    return Contract;
}());
export default Contract;
